import { CustomElement } from "../../core/CustomElement";
import { Calendar, DateRangeInput } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { DateClickArg } from "@fullcalendar/interaction";
import {
  FetchInfo,
  CalendarEvent,
  EventSourceError,
} from "../../core/interfaces/FullCalendar";
import {
  CalendarOptions,
  DateSelectArg,
  DayHeaderContentArg,
  EventContentArg,
  EventInput,
} from "@fullcalendar/common";
import Event from "../../core/interfaces/Event";
import { onElementReady } from "../../core/utilities";

export class CCCEventCalendar extends CustomElement {
  calendar: Calendar = null;
  fetchEventsCallback: (
    fetchInfo: FetchInfo,
    successCallback: (events: Array<Event>) => void,
    failureCallback: (error: EventSourceError) => void,
    currentDate: Date
  ) => void = null;
  datesSelectedCallback: (date: string) => void = null;

  constructor() {
    super();
    this.templateConfig = {
      template: require("./template.html").default,
      style: require("./style.scss").default,
    };
    this.setupComponent();
    this.loading = true;
  }

  connectedCallback(): void {
    this.innerHTML =
      '<style>@font-face {font-family: "fcicons";src: url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype");font-weight: normal;font-style: normal;}</style>';
  }

  public init(): void {
    this._initialize();
    if (!this.getAttribute("type") || this.getAttribute("type") === "picker") {
      const css = document.createElement("style");
      css.innerHTML =
        "#ccc-calendar-container.fc a:not(.fc-col-header-cell-cushion),#ccc-calendar-container.fc .fc-day:not(.fc-day-disabled, .fc-col-header-cell) {cursor: pointer;}#ccc-calendar-container.fc .fc-day:not(.fc-day-disabled, .fc-day-today, .fc-col-header-cell, .fc-event-day):hover {background-color: #1615130a;border-radius: 0.25rem;}#ccc-calendar-container.fc .fc-day.fc-day-today:hover {background-color: #1615130a;}";
      this.shadowRoot.appendChild(css);
      this.loading = false;
      this.render();
    }
  }

  public render(): void {
    if (!this.calendar.isRendered) {
      this.calendar.render();
      this.injectLoader();
    }
  }

  public onFetchEvents(
    callback: (
      fetchInfo: FetchInfo,
      successCallback: (events: Array<Event>) => void,
      failureCallback: (error: EventSourceError) => void,
      currentDate: Date
    ) => void
  ): void {
    this.fetchEventsCallback = callback;
  }

  public onDateSelected(callback: (date: string) => void): void {
    this.datesSelectedCallback = callback;
  }

  protected _initialize(): void {
    const element: HTMLElement = this.shadowDom.getElementById(
      "ccc-calendar-container"
    );
    const calendarConfig: CalendarOptions = {
      plugins: [dayGridPlugin, interactionPlugin],
      aspectRatio: 1.25,
      customButtons: {
        customNext: {
          text: "next",
          icon: "fc-icon-chevron-right",
          click: () => {
            this.calendar.next();
          },
        },
        customPrev: {
          text: "prev",
          icon: "fc-icon-chevron-left",
          click: () => {
            this.calendar.prev();
          },
        },
      },
      headerToolbar: {
        left: "customPrev",
        center: "title",
        right: "customNext",
      },
      select: function (info: DateSelectArg) {
        info.view.calendar.addEvent({
          id: "daySelected",
          start: info.startStr,
          end: info.endStr,
          display: "background",
        });
        info.view.calendar.unselect();
      },
      dateClick: (info: DateClickArg) => {
        if (
          info.dayEl.classList.contains("fc-event-day") &&
          this.getAttribute("type") === "event"
        ) {
          if (this.datesSelectedCallback) {
            this.datesSelectedCallback(info.dateStr);
          }
        } else if (
          !this.getAttribute("type") ||
          this.getAttribute("type") === "picker"
        ) {
          const tds = element.querySelectorAll(
            "table .fc-scrollgrid-sync-table td.fc-event-day"
          );
          Array.from(tds).map((td) => {
            td.classList.remove("fc-event-day");
          });
          const daySelected = this.calendar.getEventById("daySelected");
          if (daySelected) daySelected.remove();
          this.calendar.select(info.dateStr);
          if (this.datesSelectedCallback) {
            this.datesSelectedCallback(info.dateStr);
          }
        }
      },
      dayHeaderContent: (args: DayHeaderContentArg) => {
        return args.text.charAt(0);
      },
      eventClassNames: (args: EventContentArg) => {
        const element: HTMLElement = this.shadowDom.getElementById(
          "ccc-calendar-container"
        );
        const start = new Date(args.event.startStr);
        const end = new Date(args.event.endStr);
        const tds = element.querySelectorAll(
          "table .fc-scrollgrid-sync-table td"
        );
        const dateTd = Array.from(tds).filter(function (td) {
          const currentStr = td.getAttribute("data-date");
          let current: Date = null;
          if (currentStr) {
            current = new Date(currentStr);
          }
          return current >= start && current < end;
        });
        Array.from(dateTd).map((td) => {
          td.classList.add("fc-event-day");
        });
        return "";
      },
      eventDataTransform: this._eventDataTransformFunction,
    };
    if (this.getAttribute("type") === "event") {
      calendarConfig.events = (
        fetchInfo: FetchInfo,
        successCallback: (events: Array<Event>) => void,
        failureCallback: (error: EventSourceError) => void
      ) => {
        if (this.fetchEventsCallback) {
          setTimeout(() => {
            this.fetchEventsCallback(
              fetchInfo,
              successCallback,
              failureCallback,
              this.calendar ? this.calendar.getDate() : new Date()
            );
          }, 10);
        }
      };
    }
    this.calendar = new Calendar(element, calendarConfig);
    this.changeDateRange();
  }

  protected _eventDataTransformFunction(eventData: EventInput): CalendarEvent {
    const dateEnd = new Date(eventData.dateEnd.getTime());
    dateEnd.setDate(eventData.dateEnd.getDate() + 1);
    const dateStartStr = eventData.dateStart.toISOString().slice(0, 10);
    const dateEndStr = dateEnd.toISOString().slice(0, 10);
    return { start: dateStartStr, end: dateEndStr, display: "background" };
  }

  watchMinDate(): void {
    this.changeDateRange();
  }

  watchMaxDate(): void {
    this.changeDateRange();
  }

  protected changeDateRange(): void {
    if (this.calendar) {
      const opts: DateRangeInput = { start: null, end: null };
      if (this.state.minDate) {
        opts.start = this.state.minDate;
      }
      if (this.state.maxDate) {
        opts.end = this.state.maxDate;
      }
      this.calendar.setOption("validRange", opts);
    }
  }

  private injectLoader(): void {
    onElementReady(this.shadowDom, "div.fc-daygrid-body").then(
      ($div: HTMLElement) => {
        const $calendarTable = $div.querySelector(
          "table.fc-scrollgrid-sync-table"
        ) as HTMLElement;
        const $loaderDiv = document.createElement("div");
        $loaderDiv.setAttribute("id", "loader");
        $loaderDiv.style.display = "flex";
        $loaderDiv.style.justifyContent = "center";
        $loaderDiv.style.alignItems = "center";
        $loaderDiv.style.height = $calendarTable.style.height;
        $loaderDiv.style.width = $calendarTable.style.width;
        $loaderDiv.style.position = "relative";
        $loaderDiv.style.display = "none";
        const $loader = document.createElement("ccc-loader");
        $loader.setAttribute("size", "4");
        $loaderDiv.append($loader);
        $div.append($loaderDiv);
        $calendarTable.setAttribute("id", "calendar");
      }
    );
  }

  public setLoading(loading: boolean): void {
    const $calendar = this.shadowDom.querySelector(
      "table#calendar"
    ) as HTMLElement;
    const $loader = this.shadowDom.querySelector("div#loader") as HTMLElement;
    if ($calendar && $loader) {
      // if calendar is rendered, use custom loader
      $loader.style.display = loading ? "flex" : "none";
      $calendar.style.display = loading ? "none" : "table";
    } else {
      // use component loader
      this.loading = loading;
    }
  }
}

// define component
if (!customElements.get("ccc-calendar")) {
  customElements.define("ccc-calendar", CCCEventCalendar);
}
